// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"ae236fdc","149":"b8135059","175":"3cc0bd12","188":"184a5d2e","328":"b4aeffb0","330":"01523e38","417":"16e13447","435":"f32c5583","592":"8fe03e8a","597":"802b9709","660":"e1ab28cf","820":"28b0fe2a","858":"8662d0ce","943":"1d5f4755","959":"feca328c"}[chunkId] + ".chunk.js";
};